// extracted by mini-css-extract-plugin
export default {"body_bg":"login_body_bg__8Ohot","container_login":"login_container_login__-6Dzc","img_container":"login_img_container__QtrGw"};